import React from "react";
import done from "../../Images/done.png";

const ThankYouScreen = ({ data }) => {
  return (
  <div style={{ textAlign: "center", padding: "50px" }}>
    <h1 style={{ color: "#4CAF50", marginBottom: "20px" }}>
      Congratulations, <span style={{ color: "#000" }}>{data?.businessName || ""}</span> is now a member of Mediapiq’s network of marketing outlets.
    </h1>

    <h3 style={{ fontWeight: "bold" }}>
      You will receive via email information on businesses that could utilize your marketing services.
    </h3>

    <p style={{ fontSize: "16px", marginTop: "15px" }}>
      If you have any questions, you may reach us via email at{" "}
      <a href="/app/Contact">contact@mediapiq.com</a>.
    </p>

    {/* Centered image */}
    <div style={{ marginTop: "30px" }}>
      <img
        src={done}
        alt="done"
        style={{ width: "150px", height: "auto", display: "inline-block" }}
      />
    </div>
  </div>
  )
};

export default ThankYouScreen;
